import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { MenuItemCatalogGroup } from '../models/rich-data.model';
import { DataService } from '../services/data.service';

@Directive({
  selector: '[appInView]'
})
export class InViewDirective implements AfterViewInit {

  @Input() data: MenuItemCatalogGroup[];
  @Input() showData: MenuItemCatalogGroup[];
  @Input() index: number;

  constructor(
    private element: ElementRef,
    private dataServ: DataService
  ) { }

  ngAfterViewInit() {

    if (this.data[this.index + 1] && this.showData[this.showData.length - 1].menu_item_catalogs.length === 0) {
      setTimeout(() => {
        const OBSERVER = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.data && this.showData[this.index + 1].menu_item_catalogs?.length === 0) {

              this.data[this.index + 1].menu_item_catalogs?.forEach(catalog => {
                catalog.menu_item_catalog_prices.map(price => {
                  price.quantity ||= 0;
                });
              });

              this.showData[this.index + 1].menu_item_catalogs = this.data[this.index + 1].menu_item_catalogs;
            }
          });
        }, { threshold: [0, .1, .9, 1] });

        OBSERVER.observe(this.element.nativeElement);
      }, 500);
    }

  }
}
